import React, { Component, useEffect } from 'react'
import './HomePlateform.css'
import Blog from '../Blog/Blog'
import { useSelector } from 'react-redux'
import { globals } from '../Globals/Globals'


const HomePartnersBlogs = (props) => {
    const {blogsItems} = useSelector((state) => state.blogs)

    React.useEffect(() => {    
        return function cleanup() {
          document.body.classList.remove("discover");
        };
      });

        return(
            <>
                {(blogsItems || []).slice(0,3).map((blogItem, idx) => {
                    if (idx === props.blog_index) {
                        const title = blogItem?.data_blob?.data_tier?.blog_title || "Titre de blog";
                        const text = blogItem?.data_blob?.data_tier?.blog_text || "Texte d'aperçu non disponible";
                        const pictureURL = blogItem?.data_blob?.data_tier?.blog_photo || globals.dico.partners_fallback_picture;
                        const link = blogItem?.data_blob?.data_tier?.blog_link || '#';
                        return (
                            <div key={blogItem?.data_guid || idx} className="wix-blog-item">
                                <img className="wix-blog-thumb" src={pictureURL} alt={title} onClick={()=> link !== '#' && window.open(link, '_blank', 'noopener,noreferrer')} />
                                <div className="wix-blog-meta">
                                    <div className="wix-blog-title" onClick={()=> link !== '#' && window.open(link, '_blank', 'noopener,noreferrer')}>{title}</div>
                                    <div className="wix-blog-desc">{text}</div>
                                </div>
                            </div>
                        )
                    }
                })}
            </>
        )
} 

export default HomePartnersBlogs;